import React, { ReactNode } from 'react';
import classNames from 'classnames';
import './WidgetUnsupportedError.pcss';
import { Alert } from '@mm/components';
import { usePhoneNumber } from '../../../hooks/use-phone-number';

type Props = {
  className?: string;
  children?: string | ReactNode | Element[];
  isError?: boolean;
  type: 'sms' | 'instagram';
};

export const WidgetUnsupportedError = ({
  className,
  children,
  isError,
  type,
}: Props) => {
  const sms = usePhoneNumber();

  if (type === 'sms' && !sms.isSmsSupported) {
    return <></>;
  }

  const message =
    children ||
    (type === 'sms'
      ? 'This widget type is not supported on SMS and will NOT be sent in your SMS dialogue. '
      : 'This message type is NOT supported on Instagram.');

  return (
    <div className={classNames(className, 'widget-unsupported-error')}>
      <Alert
        className="widget-unsupported-error__message"
        type={isError ? 'error' : 'warning'}
        showCloseIcon={false}
      >
        {message}
      </Alert>
    </div>
  );
};
